/* Archiveren van een organisatie of contact, met bevestiging. Heeft de organisatie nog
 * lopende projecten, dan legt de dialoog uit waarom het niet kan in plaats van te
 * archiveren. */

import { type ReactNode } from 'react';
import { Archive } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

export function Archiveer({ wat, naam, uitleg, bezwaar, onArchiveer, trigger, terugzetten = 'vanuit het Archief' }: {
  /** 'organisatie' of 'contact' */
  wat: string;
  naam: string;
  /** Wat er gebeurt, bijvoorbeeld wat blijft staan. */
  uitleg?: ReactNode;
  bezwaar: string | null;
  onArchiveer: () => void;
  trigger?: ReactNode;
  /** Waar hij terug te zetten is. */
  terugzetten?: string;
}) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        {trigger ?? (
          <Button variant="ghost" size="icon" aria-label="Archiveren" title="Archiveren" className="h-8 w-8 text-muted-foreground">
            <Archive className="h-4 w-4" />
          </Button>
        )}
      </AlertDialogTrigger>
      <AlertDialogContent data-archiveren={bezwaar ? 'geweigerd' : 'bevestigen'}>
        <AlertDialogHeader>
          <AlertDialogTitle>{bezwaar ? `Deze ${wat} kan niet worden gearchiveerd` : `${wat.charAt(0).toUpperCase()}${wat.slice(1)} archiveren`}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2">
              {bezwaar ? (
                <p>{bezwaar}</p>
              ) : (
                <>
                  <p>"{naam}" verdwijnt uit de lijst. Je kunt hem terugzetten {terugzetten}.</p>
                  {uitleg && <p>{uitleg}</p>}
                </>
              )}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{bezwaar ? 'Sluiten' : 'Annuleren'}</AlertDialogCancel>
          {!bezwaar && (
            <AlertDialogAction data-archiveer-bevestig onClick={onArchiveer}>
              Archiveren
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
